module.exports = __webpack_public_path__ + "static/media/Week 5 Wednesday.77c45e14.png";